export const environment = {
    appVersion: require('../../package.json').version,
    host: 'https://www.manualradar.at/'
};
